'use strict';

const getCookie = require('util/getCookie');

function controller() {
    const vm = this;

    vm.logged_in = getCookie(document.cookie, '_bo_logged_in') !== null;
    vm.cart_counter = getCookie(document.cookie, '_bo_basket_count');

    return vm;
}

module.exports = [
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/ToolBar.js